import { doc, updateDoc, increment, setDoc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

/**
 * Track an artwork view:
 * 1. Increment global artwork view count
 * 2. Track per-user view history
 */
export const trackArtworkView = async (
  artworkId: string,
  userId: string
) => {
  try {
    // Update artwork views count
    const artworkRef = doc(db, 'artworks', artworkId);
    await updateDoc(artworkRef, {
      views: increment(1),
    });

    // Track in user's view history
    const viewRef = doc(db, 'views', `${userId}_${artworkId}`);
    const viewDoc = await getDoc(viewRef);

    if (!viewDoc.exists()) {
      await setDoc(viewRef, {
        userId,
        artworkId,
        viewCount: 1,
        firstViewedAt: new Date(),
        lastViewedAt: new Date(),
      });
    } else {
      await updateDoc(viewRef, {
        viewCount: increment(1),
        lastViewedAt: new Date(),
      });
    }
  } catch (error) {
    console.error('Error tracking artwork view:', error);
  }
};

/**
 * Fetch recently viewed artworks for a user
 * (Implementation will use Firestore query + artwork join)
 */
export const getRecentlyViewed = async (
  userId: string,
  limit: number = 10
) => {
  // TODO:
  // Query `views` collection by:
  // - userId
  // - orderBy lastViewedAt desc
  // - limit
  // Then fetch corresponding artworks

  return [];
};
